import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h2 className="text-center text-red-600 mt-10">Щось пішло не так. Спробуйте перезавантажити сторінку.</h2>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
